import styled from 'styled-components';

export const StyledLoading = styled.div`
  justify-content: center;
  align-items: center;
  min-height: 240px;
  padding: var(--space-7) 0;
`;
